import React from 'react'
import './style.scss';

const Datedetails = ({date,day,time,hrs}) => {
  return (
    <div className="date-details-container">
                <p className="day-date">{date} : {day}</p>
                <div className="time-container">
                  <p className="time">
                    {time}
                  </p>
                  <p className="time">
                   <small>{hrs}</small>
                  </p>
                </div>
              </div>
  )
}

export default Datedetails